module.exports = __webpack_public_path__ + "static/media/karna_stemleaf.cf58541b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/karna/karna_stemleaf.png
// module id = 399
// module chunks = 0